<template>
    <div class="layout-mt">
        <div v-if="type===1" class="content-empty">
            <div class="img-box img-type-1"/><p>{{ message }}</p>
        </div>
        <div v-else-if="type===2" class="content-empty">
            <div class="img-box img-type-resources"/><p>{{ message }}</p>
        </div>
        <div v-else-if="type===3" class="content-empty">
            <div class="img-box img-type-permission"/><p>{{ message }}</p>
        </div>
        <div v-else class="content-empty">
            <div class="img-box img-type-overrun"/><p>{{ message }}</p>
        </div>
        <div class="text-center">
            <a class="btn" href="javascript:window.opener=null;window.open('','_self');window.close();">
                {{ $t("lang.close") }}</a>
        </div>
    </div>
</template>
<script>
    import * as error from '@/util/special-errors';

    const codeType = {
        ordinaryCode: 1,
        emptyCode: 2,
        authCode: 3,
        memberLimitCode: 4
    };
    export default {
        data() {
            return {
                errorCode: '',
                message: ''
            };
        },
        mounted() {
            this.errorCode = this.$route.params.code;
            this.message = this.$i18n.t(`lang.${this.errorCode}`);
        },
        computed: {
            type() {
                if (error.isEmptyCode(this.errorCode)) {
                    return codeType.emptyCode;
                }
                if (error.isAuthCode(this.errorCode)) {
                    return codeType.authCode;
                }
                if (error.isMemberLimitCode(this.errorCode)) {
                    return codeType.memberLimitCode;
                }
                return codeType.ordinaryCode;
            }
        }

    };
</script>
